import react from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { FacebookIcon, FacebookShareButton } from "react-share";

function LitterBowieGoose01Puppies() {
  return (
    <div>
      <Helmet>
        <title>Bowie and Goose Puppies - High Altitude Labs</title>
        <link
          rel="canonical"
          href="https://highaltitudelabs.com/litters/previous/bowie_goose_2025/puppies"
        />
        <meta
          property="og:url"
          content="https://highaltitudelabs.com/litters/previous/bowie_goose_2025/puppies"
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Puppies Available" />
        <meta
          property="og:description"
          content="English Labrador Retriever Puppies"
        />
        <meta
          property="og:image"
          content="https://highaltitudelabs.com/img/bowielitter02/p01.jpg"
        />
      </Helmet>
      <div id="fb-root"></div>

      <div>
        <h3>Bowie and Goose</h3>{" "}
        <p className="hangingindent">
          <h6>Puppies Whelped 2025-07-06</h6>

          <p className="hangingindent">
            Black Puppies
          </p>
        </p>
        <section className="littercontainer">
          <div className="container">
            <div className="row">
              <div className="col s12 s12">
                <img src="/img/bowielitter02/p03.jpg" alt="" />
              </div>
            </div>
            <div className="row">
              <div className="col s12 m6">
                <img src="/img/bowielitter02/p01.jpg" />
              </div>
              <div className="col s12 m6">
                <img src="/img/bowielitter02/p02.jpg" />
              </div>
            </div>
          </div>
        </section>
        <br></br>
      </div>
    </div>
  );
}

export default LitterBowieGoose01Puppies;
